module.exports = __webpack_public_path__ + "static/media/bio_fiona_2.96d51373.jpg";